// components/GallerySection.jsx

import React from "react";
import styles from "../styles/GallerySection.module.css";
import gallery1 from "../images/mesogeios-interior.jpg";
import gallery2 from "../images/mesogeios-restaurant.jpg";
import gallery3 from "../images/mesogeios-tables.jpg";
import gallery4 from "../images/mesogeios-view.jpg";

const images = [
  gallery1,
  gallery2,
  gallery3,
  gallery4,
];

export default function GallerySection() {
  return (
    <section className={styles.section} id="gallery">
      <div className={styles.container}>
        <span>Gallery</span>

        <h2>Moments & Atmosphere</h2>

        <div className={styles.grid}>
          {images.map((image, index) => (
            <div className={styles.imageWrapper} key={index}>
              <img src={image} alt="Restaurant Gallery" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}